var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7412_129807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 8.17505C35.2091 8.17505 37 6.38419 37 4.17505C37 1.96591 35.2091 0.175049 33 0.175049C30.7909 0.175049 29 1.96591 29 4.17505C29 6.38419 30.7909 8.17505 33 8.17505Z",
    fill: "#FF5E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 10.175H30C27.8 10.175 26 11.975 26 14.175V26.175H29V40.175H37V26.175H40V14.175C40 11.975 38.2 10.175 36 10.175Z",
    fill: "#FF5E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.175C6.65685 19.175 8 17.8319 8 16.175C8 14.5182 6.65685 13.175 5 13.175C3.34315 13.175 2 14.5182 2 16.175C2 17.8319 3.34315 19.175 5 19.175Z",
    fill: "#FF5E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21.175H3C1.36 21.175 0 22.535 0 24.175V32.175H2V40.1751H8V32.175H10V24.175C10 22.535 8.64 21.175 7 21.175Z",
    fill: "#FF5E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.675C19.933 13.675 21.5 12.108 21.5 10.175C21.5 8.24205 19.933 6.67505 18 6.67505C16.067 6.67505 14.5 8.24205 14.5 10.175C14.5 12.108 16.067 13.675 18 13.675Z",
    fill: "#FF5E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.675H15.5C13.58 15.675 12 17.255 12 19.175V29.175H14.5V40.175H21.5V29.175H24V19.175C24 17.255 22.42 15.675 20.5 15.675Z",
    fill: "#FF5E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7412_129807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.175049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.05854c673f1e66dfa262de2044c78ed7.svg";
export { ForwardRef as ReactComponent };